import React, {Component} from 'react';
import {Button, Col, Form, Icon, Input, Popconfirm, Row, Select, Table, notification} from 'antd';
import {AuthenticatedLayout} from "../../layouts";
import {Container, PeriodSelect} from "../../components";
import {ShowErrorNotification, ShowValidationErrorNotification} from "../../utils";
import CreateModal from "./CreateModal";
import EditModal from "./EditModal";
import CopyModal from "./CopyModal";
import data from '../../data';

let handleCopy;
let handleDelete;
let handleEnable;
let handleDisable;

class PlansPage extends Component {
    state = {
        filter: {enabled: 'active'}
    };

    constructor(props) {
        super(props);
        this.loadData = this.loadData.bind(this);
        this.handlePeriodChange = this.handlePeriodChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.showCopyModal = this.showCopyModal.bind(this);
        this.closeCopyModal = this.closeCopyModal.bind(this);
        handleCopy = this.handleCopy = this.handleCopy.bind(this);
        handleDelete = this.handleDelete = this.handleDelete.bind(this);
        handleEnable = this.handleEnable = this.handleEnable.bind(this);
        handleDisable = this.handleDisable = this.handleDisable.bind(this);
        this.openCreateModal = this.openCreateModal.bind(this);
        this.closeCreateModal = this.closeCreateModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
    }

    loadData(filter) {
        if (!this.state.period_id) {
            this.setState({plans: undefined});
            return;
        }
        let enabled = undefined;
        if (filter?.enabled === 'active') {
            enabled = true;
        } else if (filter?.enabled === 'passive') {
            enabled = false;
        }
        this.setState({loading: true});
        data.allPlans({...filter, enabled, period_id: this.state.period_id})
            .then(plans => this.setState({plans, filter}))
            .catch(err => ShowErrorNotification('Ders planları alınamadı', err))
            .finally(() => this.setState({loading: false}));
    }

    handlePeriodChange(period_id) {
        this.setState({period_id}, () => {
            this.loadData(this.state.filter);
        });
    }

    handleSearch(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return ShowValidationErrorNotification();
            }
            this.loadData(values);
        });
    }

    handleCopy(e, record) {
        e.stopPropagation();
        this.showCopyModal(record);
    }

    handleDelete(record) {
        this.setState({loading: true});
        data.deletePlan(record.id)
            .then(() => notification.success({
                message: 'Ders planı silindi'
            }))
            .catch(err => ShowErrorNotification('Ders planı silinemedi', err))
            .finally(() => this.loadData(this.state.filter));
    }

    handleEnable(record) {
        this.setState({loading: true});
        data.enablePlan(record.id)
            .then(() => notification.success({
                message: 'Ders planı gösterildi'
            }))
            .catch(err => ShowErrorNotification('Ders planı gösterilemedi', err))
            .finally(() => this.loadData(this.state.filter));
    }

    handleDisable(record) {
        this.setState({loading: true});
        data.disablePlan(record.id)
            .then(() => notification.success({
                message: 'Ders planı gizlendi'
            }))
            .catch(err => ShowErrorNotification('Ders planı gizlenemedi', err))
            .finally(() => this.loadData(this.state.filter));
    }

    showCopyModal(record) {
        this.setState({record, copyModalVisible: true});
    }

    closeCopyModal(newPlan) {
        this.setState({copyModalVisible: false}, () => {
            if (newPlan) this.props.history.push(`/plans/${newPlan.id}`);
        });
    }

    openCreateModal() {
        this.setState({createModalVisible: true});
    }

    closeCreateModal(record) {
        this.setState({createModalVisible: false});
        if (record) this.loadData(this.state.filter);
    }

    openEditModal(record) {
        this.setState({record, editModalVisible: true});
    }

    closeEditModal(record) {
        this.setState({record: undefined, editModalVisible: false});
        if (record) this.loadData(this.state.filter);
    }

    renderSearchForm() {
        const {getFieldDecorator} = this.props.form;
        return (
            <Form onSubmit={this.handleSearch}>
                <Row type="flex" gutter={16}>
                    <Col>
                        <Form.Item label="Eğitim-Öğretim Yılı">
                            <PeriodSelect
                                placeholder="Yıl seçin"
                                onChange={this.handlePeriodChange}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item label="Ad">
                            {getFieldDecorator('name')(<Input autoFocus prefix={<Icon type="search"/>}/>)}
                        </Form.Item>
                    </Col>
                    <Col style={{width: 120}}>
                        <Form.Item label="Durum">
                            {getFieldDecorator('enabled', {
                                initialValue: this.state.filter.enabled
                            })(
                                <Select placeholder="Hepsi">
                                    <Select.Option key="active">Aktif</Select.Option>
                                    <Select.Option key="passive">Pasif</Select.Option>
                                    <Select.Option key="all">Hepsi</Select.Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row
                    type="flex"
                    gutter={[8,8]}
                    style={{marginBottom: 8}}
                >
                    <Col>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon="search"
                            loading={this.state.loading}
                        >
                            Ara
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            icon="plus"
                            onClick={this.openCreateModal}
                        >
                            Yeni Ders Planı
                        </Button>
                    </Col>
                </Row>
            </Form>
        );
    }

    componentDidMount() {
        this.loadData(this.state.filter);
    }

    render() {
        return (
            <AuthenticatedLayout>
                <Container>
                    <div className="page">
                        <h1 className="page-header">Ders Planları</h1>
                        {this.renderSearchForm()}
                        <Table
                            rowKey="id"
                            loading={this.state.loading}
                            columns={columns}
                            dataSource={this.state.plans}
                            pagination={{style: {marginRight: 16}}}
                            onRow={record => ({
                                style: {cursor: 'pointer'},
                                onClick: () => this.openEditModal(record)
                            })}
                        />
                        <CreateModal
                            visible={this.state.createModalVisible}
                            onClose={this.closeCreateModal}
                        />
                        <EditModal
                            visible={this.state.editModalVisible}
                            record={this.state.record}
                            onClose={this.closeEditModal}
                        />
                        <CopyModal
                            record={this.state.record}
                            visible={this.state.copyModalVisible}
                            onClose={this.closeCopyModal}
                        />
                    </div>
                </Container>
            </AuthenticatedLayout>
        );
    }
}

const columns = [{
    dataIndex: 'enabled',
    key: 'enabled',
    width: 16,
    render: (text, record) => (
        <Icon
            type={record.enabled ? "check-circle" : "close-circle"}
            style={{color: record.enabled ? "green" : "red"}}
        />
    )
}, {
    dataIndex: 'published',
    key: 'published',
    width: 16,
    render: (text, record) => (
        <Icon
            type={record.published ? "eye" : "eye-invisible"}
            style={{color: record.published ? "blue" : "red"}}
        />
    )
}, {
    title: 'Ad (Türkçe)',
    dataIndex: 'name_tr',
    key: 'name_tr'
}, {
    title: 'Ad (Almanca)',
    dataIndex: 'name_de',
    key: 'name_de'
}, {
    render: (text, record) => (
        <Row type="flex" gutter={[4,4]} justify="end">
            <Col>
                {record.enabled ? (
                    <Button
                        icon="eye-invisible"
                        onClick={e => {
                            e.stopPropagation();
                            handleDisable(record);
                        }}
                    >
                        Gizle
                    </Button>
                ) : (
                    <Button
                        icon="eye"
                        onClick={e => {
                            e.stopPropagation();
                            handleEnable(record);
                        }}
                    >
                        Göster
                    </Button>
                )}
            </Col>
            <Col>
                <Button icon="copy" onClick={e => handleCopy(e, record)}>Kopyala</Button>
            </Col>
            <Col>
                <Popconfirm
                    title={(
                        <div>
                            <h3>DİKKAT!</h3>
                            <p>Ders planını silmek üzeresiniz ve bu işlemin geri dönüşü olmayacaktır.</p>
                            <p>Devam etmek istediğinize emin misiniz？</p>
                        </div>
                    )}
                    okText="Evet"
                    onConfirm={e => {
                        e.stopPropagation();
                        handleDelete(record);
                    }}
                    cancelText="Hayır"
                    onCancel={e => e.stopPropagation()}
                >
                    <Button
                        type="danger"
                        icon="delete"
                        onClick={e => e.stopPropagation()}>
                        Sil
                    </Button>
                </Popconfirm>
            </Col>
        </Row>
    )
}];

export default Form.create()(PlansPage);
